var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 389,
    viewBox: "0 0 435 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.064 317.876L169.115 207.918H287.728L434 304.716",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.064 317.876L169.115 207.918H287.728L434 304.716",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.921 313.547L169.115 215.253V207.918L221.186 323L205.921 313.547Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.931 212.467L287.383 271.798L226.142 286.11L191.345 219.79L236.931 212.467Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.143 286.111V287.861L286.338 275.644L287.383 271.799L226.143 286.111Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.026 233.815L237.609 237.637L244.173 235.853L241.442 232.122L235.026 233.815Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259.873 257.201L256.751 252.964L249.291 254.979L252.206 259.309L259.873 257.201Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.669 225.849L231.586 228.704L237.76 227.127L235.821 224.479L229.669 225.849Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.557 243.501L245.091 248.751L252.31 246.92L248.408 241.612L241.557 243.501Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.252 245.965L254.066 247.542L257.165 251.756L263.466 250.052L260.252 245.965Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.72 249.67L248.669 254.068L256.083 252.054L252.973 247.816L245.72 249.67Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.678 227.401L224.583 230.487L230.505 228.967L228.565 226.089L222.678 227.401Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.217 238.548L240.948 242.589L247.743 240.701L244.839 236.751L238.217 238.548Z",
    fill: "#666666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.203 229.615L234.407 232.896L240.765 231.215L238.424 228.026L232.203 229.615Z",
    fill: "#666666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.84 237.015L216.912 233.526L209.877 235.322L211.839 238.868L218.84 237.015Z",
    fill: "#666666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.735 245.456L213.567 244.155L211.329 240.103L206.577 241.358L208.735 245.456Z",
    fill: "#666666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.586 224.019L222.089 226.46L227.931 225.159L226.359 222.833L220.586 224.019Z",
    fill: "#666666"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.389 232.571L214.53 229.208L207.38 230.786L209.354 234.367L216.389 232.571Z",
    fill: "#666666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.645 225.435L215.068 228.014L221.013 226.701L219.486 224.237L213.645 225.435Z",
    fill: "#666666"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.648 235.832L208.307 234.634L206.31 231.03L201.662 232.055L203.648 235.832Z",
    fill: "#666666"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M205.358 227.136L206.85 229.83L214 228.253L212.566 225.651L205.358 227.136Z",
    fill: "#666666"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.819 235.728L230.229 239.631L236.542 237.927L233.959 234.104L227.819 235.728Z",
    fill: "#666666"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M244.023 249.023L240.5 243.796L233.924 245.615L237.114 250.785L244.023 249.023Z",
    fill: "#666666"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.596 228.968L217.432 232.307L223.515 230.752L221.598 227.644L215.596 228.968Z",
    fill: "#666666"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M216.973 250.302L212.015 251.672L214.585 256.543L219.693 255.242L216.973 250.302Z",
    fill: "#666666"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M230.803 240.562L233.351 244.684L239.881 242.887L237.161 238.834L230.803 240.562Z",
    fill: "#666666"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.192 235.081L224.092 231.684L217.963 233.25L219.891 236.75L226.192 235.081Z",
    fill: "#666666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 271.18L230.688 272.976L233.189 277.501L240.225 275.762L237.7 271.18Z",
    fill: "#666666"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M226.844 221.67L232.847 220.438L229.622 216.04L223.711 217.019L226.844 221.67Z",
    fill: "#666666"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M212.038 224.698L209.134 219.437L201.777 220.657L204.83 226.184L212.038 224.698Z",
    fill: "#666666"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.586 241.977L219.371 237.959L212.37 239.813L214.608 243.866L221.586 241.977Z",
    fill: "#666666"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.457 256.569L236.633 251.998L229.334 253.863L231.951 258.607L239.457 256.569Z",
    fill: "#666666"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M236.058 251.063L232.868 245.905L225.993 247.805L228.805 252.905L236.058 251.063Z",
    fill: "#666666"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M247.605 254.355L244.644 249.945L237.689 251.718L240.513 256.278L247.605 254.355Z",
    fill: "#666666"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M229.174 239.916L226.763 236.001L220.405 237.694L222.62 241.689L229.174 239.916Z",
    fill: "#666666"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.155 231.419L227.244 234.793L233.338 233.181L231.123 229.888L225.155 231.419Z",
    fill: "#666666"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M232.292 244.986L229.744 240.853L223.134 242.637L225.475 246.874L232.292 244.986Z",
    fill: "#666666"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.151 259.608L248.225 255.279L241.086 257.213L243.806 261.623L251.151 259.608Z",
    fill: "#666666"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M246.433 267.864L243.323 262.832L235.473 264.997L238.227 269.959L246.433 267.864Z",
    fill: "#666666"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M222.905 261.055L220.219 256.185L215.089 257.497L217.706 262.471L222.905 261.055Z",
    fill: "#666666"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M214.091 245.1L209.236 246.412L211.52 250.73L216.444 249.371L214.091 245.1Z",
    fill: "#666666"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M237.174 270.235L234.442 265.272L227.487 267.184L230.161 272.02L237.174 270.235Z",
    fill: "#666666"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M224.431 247.151L222.101 242.926L215.123 244.814L217.487 249.086L224.431 247.151Z",
    fill: "#666666"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.474 222.602L229.034 224.917L235.14 223.558L233.522 221.359L227.474 222.602Z",
    fill: "#666666"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M201.155 231.099L205.78 230.074L204.288 227.357L199.675 228.301L201.155 231.099Z",
    fill: "#666666"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M219.992 223.063L225.73 221.888L222.574 217.202L216.95 218.135L219.992 223.063Z",
    fill: "#666666"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M213.116 224.479L218.912 223.293L215.836 218.319L210.224 219.252L213.116 224.479Z",
    fill: "#666666"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M210.811 239.158L208.837 235.589L204.154 236.786L206.071 240.402L210.811 239.158Z",
    fill: "#666666"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.97 220.208L239.157 219.137L235.898 215.003L230.768 215.844L233.97 220.208Z",
    fill: "#666666"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M203.75 226.403L200.674 220.831L196.129 221.59L199.17 227.336L203.75 226.403Z",
    fill: "#666666"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M229.647 273.238L224.138 274.642L226.525 279.156L232.148 277.763L229.647 273.238Z",
    fill: "#666666"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M255.821 266.541L248.062 268.521L250.897 273.115L258.908 271.123L255.821 266.541Z",
    fill: "#666666"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247.006 268.795L238.743 270.902L241.28 275.496L249.83 273.377L247.006 268.795Z",
    fill: "#666666"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M265.003 264.19L256.9 266.263L259.988 270.857L268.377 268.773L265.003 264.19Z",
    fill: "#666666"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M272.98 262.152L266.094 263.914L269.479 268.508L276.595 266.735L272.98 262.152Z",
    fill: "#666666"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M226.455 267.471L221.118 268.933L223.632 273.7L229.118 272.296L226.455 267.471Z",
    fill: "#666666"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M242.75 261.908L240.03 257.498L232.479 259.548L234.958 264.049L242.75 261.908Z",
    fill: "#666666"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M255.203 265.618L251.759 260.517L244.38 262.544L247.49 267.587L255.203 265.618Z",
    fill: "#666666"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M233.926 264.33L231.435 259.828L224.469 261.727L226.971 266.241L233.926 264.33Z",
    fill: "#666666"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M220.624 267.989L225.938 266.526L223.436 262.001L218.214 263.418L220.624 267.989Z",
    fill: "#666666"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M227.763 253.182L224.963 248.093L218.008 250.016L220.739 254.967L227.763 253.182Z",
    fill: "#666666"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M264.338 263.282L260.54 258.112L252.827 260.23L256.282 265.343L264.338 263.282Z",
    fill: "#666666"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M230.916 258.882L228.287 254.127L221.264 255.923L223.949 260.782L230.916 258.882Z",
    fill: "#666666"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M249.487 241.312L253.401 246.632L259.541 245.066L255.318 239.7L249.487 241.312Z",
    fill: "#666666"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M241.856 230.927L247.296 229.488L244.852 226.391L239.526 227.749L241.856 230.927Z",
    fill: "#666666"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M236.942 224.234L238.848 226.836L244.15 225.489L242.233 223.06L236.942 224.234Z",
    fill: "#666666"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M272.271 261.252L268.162 256.014L261.62 257.81L265.43 263.003L272.271 261.252Z",
    fill: "#666666"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M242.52 231.837L245.262 235.555L250.863 234.036L247.994 230.386L242.52 231.837Z",
    fill: "#666666"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.828 252.662L260.95 256.911L267.457 255.126L264.163 250.946L257.828 252.662Z",
    fill: "#666666"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M236.255 223.314L241.523 222.151L239.882 220.056L234.66 221.126L236.255 223.314Z",
    fill: "#666666"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M248.823 240.416L254.619 238.804L251.577 234.935L245.931 236.466L248.823 240.416Z",
    fill: "#666666"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M295.383 219.1V228.518C294.429 229.443 293.379 230.261 292.25 230.959C290.517 232.007 276.251 234.413 276.251 234.413L294.338 254.321C294.338 254.321 310.922 252.501 315.571 251.177C320.437 249.773 319.392 231.972 319.392 231.972L295.383 219.1Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M295.383 219.1V228.518C295.383 228.518 295.131 228.771 294.718 229.14L315.87 251.085C320.391 249.047 319.393 232.007 319.393 232.007L295.383 219.1Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M263.375 98.6655V198.503L339.225 258.536V104.25L263.375 98.6655Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M268.597 103.904V188.024L332.27 227.471V109.488L268.597 103.904Z",
    fill: "#605BFF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M346.878 104.251H339.223V258.572H346.878V104.251Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M272.774 109.142L273.119 184.19L326.348 214.552V121.623L289.817 116.073L287.384 110.881L272.774 109.142Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M276.251 118.214V182.093L323.226 207.228V126.596L276.251 118.214Z",
    fill: "#605BFF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M303.724 180.565C310.352 178.332 313.239 169.094 310.172 159.932C307.105 150.769 299.246 145.15 292.619 147.383C285.991 149.615 283.104 158.853 286.171 168.016C289.237 177.179 297.096 182.797 303.724 180.565Z",
    fill: "#666666"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M299.559 165.021L304.023 160.058C304.324 159.616 304.479 159.09 304.464 158.554C304.45 158.019 304.267 157.502 303.943 157.076C303.277 156.121 302.233 155.925 301.648 156.604L297.355 161.383L293.051 154.474C292.432 153.472 291.387 153.162 290.756 153.783C290.423 154.196 290.234 154.706 290.218 155.236C290.201 155.766 290.358 156.287 290.664 156.719L295.129 163.916L290.584 168.855C290.283 169.298 290.129 169.825 290.146 170.361C290.162 170.897 290.348 171.414 290.676 171.837C290.938 172.254 291.348 172.554 291.823 172.678C292.03 172.729 292.247 172.722 292.449 172.657C292.652 172.592 292.833 172.471 292.971 172.309L297.275 167.531L301.567 174.439C301.831 174.909 302.268 175.256 302.784 175.406C302.982 175.469 303.194 175.476 303.396 175.428C303.598 175.379 303.783 175.276 303.931 175.13C304.261 174.716 304.447 174.205 304.461 173.676C304.476 173.146 304.318 172.626 304.012 172.194L299.559 165.021Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M284.597 139.862L310.902 147.611",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M283.549 132.53L317.646 142.075",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M307.054 297.016C307.054 297.016 290.425 298.559 284.273 303.499C278.121 308.438 282.735 310.914 288.577 312.457C294.418 313.999 320.597 311.524 323.983 308.127C327.368 304.731 323.983 296.395 307.054 297.016Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M323.985 308.17C324.639 307.515 325.045 306.652 325.133 305.729C317.685 305.361 307.918 307.526 299.046 310.335C296.051 311.291 293.01 312.094 289.934 312.741C297.669 313.674 320.818 311.302 323.985 308.17Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M248.098 113.771L260.252 120.116",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M241.121 110.133L244.736 112.022",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M250.771 145.734L254.892 146.206",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M235.001 143.902L246.111 145.192",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M253.368 175.382L239.596 179.216",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M235.589 6.51123C229.074 6.51123 222.706 8.44928 217.289 12.0803C211.873 15.7113 207.651 20.8722 205.158 26.9104C202.665 32.9485 202.012 39.5928 203.283 46.0028C204.554 52.4129 207.691 58.301 212.298 62.9224C216.904 67.5438 222.773 70.691 229.163 71.9661C235.552 73.2411 242.175 72.5867 248.194 70.0856C254.213 67.5845 259.357 63.3491 262.976 57.9149C266.596 52.4807 268.527 46.0918 268.527 39.5561C268.527 30.7921 265.057 22.387 258.88 16.1899C252.703 9.99274 244.325 6.51123 235.589 6.51123ZM235.589 66.1072C230.355 66.1049 225.239 64.5458 220.889 61.6269C216.538 58.7081 213.147 54.5606 211.146 49.7088C209.145 44.857 208.622 39.5188 209.645 34.3692C210.667 29.2196 213.189 24.4897 216.89 20.7776C220.592 17.0655 225.308 14.5379 230.441 13.5144C235.575 12.4909 240.896 13.0173 245.731 15.0272C250.566 17.0372 254.699 20.4403 257.606 24.8063C260.514 29.1724 262.066 34.3053 262.066 39.5561C262.072 43.0471 261.391 46.5051 260.063 49.7318C258.735 52.9586 256.785 55.8907 254.326 58.3603C251.866 60.8299 248.945 62.7885 245.73 64.1237C242.515 65.459 239.069 66.1447 235.589 66.1417V66.1072Z",
    fill: "#666666"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M237.942 39.5889C237.954 40.058 237.825 40.5199 237.574 40.9156C237.322 41.3112 236.959 41.6227 236.53 41.8102C236.101 41.9977 235.627 42.0527 235.167 41.9683C234.706 41.8838 234.282 41.6637 233.947 41.336C233.612 41.0083 233.382 40.5879 233.287 40.1286C233.191 39.6692 233.234 39.1917 233.411 38.757C233.587 38.3224 233.888 37.9503 234.276 37.6883C234.664 37.4263 235.122 37.2863 235.589 37.2861C236.204 37.2859 236.793 37.5267 237.233 37.957C237.673 38.3873 237.927 38.9729 237.942 39.5889Z",
    fill: "#666666"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M227.704 51.5768L235.589 39.5908L248.913 50.6557",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7974 64.9224L56.8379 54.0648L58.9496 56.4482V52.7407L63.4371 59.6261L59.4776 34.9978L64.7569 48.5036L65.2848 36.5867L66.0767 40.559L67.1326 27.0532L68.9804 47.7092L71.62 40.559L71.0921 49.8277L78.2192 28.6421L74.7876 55.1241L79.803 51.4166L76.8994 56.1834L80.5949 53.5352L76.3829 65.7169L61.0614 65.9817",
    fill: "#605BFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M77.734 91.6687H61.2304L56.7773 62.9761H82.1755L77.734 91.6687Z",
    fill: "#666666",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M122.919 91.4717H39.6084V313.817H122.919V91.4717Z",
    fill: "white",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 98.7734H44.4541V152.325H117.252V98.7734Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4087 120.682H66.292V130.423H95.4087V120.682Z",
    fill: "#666666"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 161.26H44.4541V214.811H117.252V161.26Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4087 183.168H66.292V192.909H95.4087V183.168Z",
    fill: "#666666"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 223.736H44.4541V277.287H117.252V223.736Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4087 245.645H66.292V255.386H95.4087V245.645Z",
    fill: "#666666"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M131.852 301.124C131.852 301.124 173.604 282.621 196.053 281.228L212.43 317.531H88.7334L131.852 301.124Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M182.67 82.3813C182.67 82.3813 212.062 117.407 218.248 123.831C224.434 130.256 224.664 134.919 222.667 137.798C220.67 140.676 205.658 146.007 190.187 155.978C174.717 165.949 130.738 191.671 130.301 192.569C129.865 193.467 125.653 161.482 125.653 161.482L199.243 131.108L199.025 128.886L175.153 84.546L182.67 82.3813Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M210.958 134.083L176.849 84.1128L175.208 84.5964L199.079 128.936L199.297 131.159L125.708 161.532C125.708 161.532 125.788 162.085 125.903 163.018L130.7 174.059L210.958 134.083Z",
    fill: "#605BFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.958 134.083L176.849 84.1128L175.208 84.5964L199.079 128.936L199.297 131.159L125.708 161.532C125.708 161.532 125.788 162.085 125.903 163.018L130.7 174.059L210.958 134.083Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M182.67 82.3813C182.67 82.3813 212.062 117.407 218.248 123.831C224.434 130.256 224.664 134.919 222.667 137.798C220.67 140.676 205.658 146.007 190.187 155.978C174.717 165.949 130.738 191.671 130.301 192.569C129.865 193.467 125.653 161.482 125.653 161.482L199.243 131.108L199.025 128.886L175.153 84.546L182.67 82.3813Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M159.247 67.0824C159.247 67.0824 155.712 63.9736 153.944 67.0824C152.177 70.1911 151.959 75.2802 153.061 75.7293C154.162 76.1783 158.581 75.5105 159.247 74.1749C159.912 72.8393 159.247 67.0824 159.247 67.0824Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M165.432 65.528C165.432 65.528 161.679 61.5442 159.246 63.0871C156.813 64.6299 157.478 73.0696 158.362 73.7374C159.246 74.4052 164.548 72.586 165.248 71.5153C165.948 70.4445 165.432 65.528 165.432 65.528Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M173.831 65.7476C173.831 65.7476 170.514 61.1421 167.427 61.1421C164.34 61.1421 162.113 72.23 163.227 73.1166C164.34 74.0031 171.616 72.8978 172.064 72.23C172.772 70.1038 173.362 67.9397 173.831 65.7476Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M180.292 73.2875C180.292 71.9634 179.638 60.4265 175.702 61.0943C171.765 61.7621 167.53 71.0768 167.748 72.6082C167.966 74.1395 180.292 73.2875 180.292 73.2875Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M199.239 131.156C199.239 131.156 210.51 135.37 214.71 135.14L199.239 131.156Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M199.239 131.156C199.239 131.156 210.51 135.37 214.71 135.14",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M106.564 317.83C118.569 315.803 133.948 307.525 138.527 297.105C135.084 279.04 130.734 253.594 130.734 238.027C130.734 211.867 137.621 197.015 134.487 179.306C131.354 161.598 124.767 150.049 117.697 145.386C117.697 145.386 106.874 148.265 95.822 158.685C84.7698 169.105 75.049 187.02 71.2616 204.096C67.4743 221.171 62.4245 273.709 62.4245 287.456C62.4245 301.204 61.4375 318.267 61.4375 318.267C74.6703 318.267 87.903 318.267 101.136 318.267C102.955 318.285 104.772 318.139 106.564 317.83Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M138.527 297.096C131.802 302.853 101.515 314.033 97.0959 315.023C92.6774 316.013 95.1334 306.641 102.008 297.28C108.883 287.919 93.6529 300.734 91.1969 301.713C88.7408 302.692 92.1839 283.475 92.1839 274.079C92.1839 264.684 101.032 184.87 101.032 184.87L117.731 154.3L123.47 150.846C121.867 148.709 119.929 146.846 117.731 145.331C117.731 145.331 106.909 148.21 95.8564 158.63C84.8043 169.05 75.049 187.023 71.2616 204.098C67.4743 221.173 62.4245 273.711 62.4245 287.459C62.4245 301.206 61.4375 318.27 61.4375 318.27C74.6703 318.27 87.903 318.27 101.136 318.27C102.948 318.271 104.758 318.109 106.541 317.786C118.569 315.806 133.948 307.527 138.527 297.096Z",
    fill: "#605BFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.527 297.096C131.802 302.853 101.515 314.033 97.0959 315.023C92.6774 316.013 95.1334 306.641 102.008 297.28C108.883 287.919 93.6529 300.734 91.1969 301.713C88.7408 302.692 92.1839 283.475 92.1839 274.079C92.1839 264.684 101.032 184.87 101.032 184.87L117.731 154.3L123.47 150.846C121.867 148.709 119.929 146.846 117.731 145.331C117.731 145.331 106.909 148.21 95.8564 158.63C84.8043 169.05 75.049 187.023 71.2616 204.098C67.4743 221.173 62.4245 273.711 62.4245 287.459C62.4245 301.206 61.4375 318.27 61.4375 318.27C74.6703 318.27 87.903 318.27 101.136 318.27C102.948 318.271 104.758 318.109 106.541 317.786C118.569 315.806 133.948 307.527 138.527 297.096Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M106.564 317.83C118.569 315.803 133.948 307.525 138.527 297.105C135.084 279.04 130.734 253.594 130.734 238.027C130.734 211.867 137.621 197.015 134.487 179.306C131.354 161.598 124.767 150.049 117.697 145.386C117.697 145.386 106.874 148.265 95.822 158.685C84.7698 169.105 75.049 187.02 71.2616 204.096C67.4743 221.171 62.4245 273.709 62.4245 287.456C62.4245 301.204 61.4375 318.267 61.4375 318.267C74.6703 318.267 87.903 318.267 101.136 318.267C102.955 318.285 104.772 318.139 106.564 317.83V317.83Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M117.057 149.462L136.039 184.142L137.061 203.163C137.061 203.163 142.352 189.599 139.999 180.745C137.646 171.891 117.057 149.462 117.057 149.462Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M137.049 203.175L131.758 283.438L137.645 299.96L141.766 266.904L138.231 200.803L137.049 203.175Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M131.839 116.962C131.839 116.962 132.505 125.609 133.17 129.823C133.836 134.037 123.449 145.827 123.449 145.827L138.473 168.659L155.493 155.36C155.493 155.36 179.594 153.587 181.786 151.584C183.978 149.58 184.001 127.646 184.001 127.646L189.739 124.319C189.739 124.319 184.437 101.291 183.117 96.156L181.786 91.0668C181.786 91.0668 189.521 88.3956 187.754 80.7043C185.987 73.013 174.716 69.1904 163.446 70.9405C152.176 72.6907 149.307 76.9278 149.307 76.9278C149.307 76.9278 133.388 76.709 124.333 84.2506C115.278 91.7922 120.798 103.755 123.667 107.969C126.109 111.213 128.845 114.223 131.839 116.962Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M158.487 147.931C154.069 142.508 158.487 121.806 161.93 111.455C165.373 101.104 157.018 96.671 157.018 96.671L182.107 92.3303L181.762 91.0292C183.459 90.364 184.968 89.2928 186.158 87.909L187.512 79.9068C185.217 72.63 174.348 69.1298 163.411 70.8454C152.141 72.6185 149.272 76.8326 149.272 76.8326C149.272 76.8326 133.353 76.6138 124.298 84.1554C115.243 91.697 120.763 103.66 123.632 107.874C126.069 111.15 128.805 114.191 131.804 116.959C131.804 116.959 132.469 125.605 133.135 129.82C133.801 134.034 123.449 145.824 123.449 145.824L138.472 168.656L155.492 155.357C155.492 155.357 173.855 153.999 180.006 152.329L181.785 151.581C181.785 151.581 162.929 153.354 158.487 147.931Z",
    fill: "#605BFF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.487 147.931C154.069 142.508 158.487 121.806 161.93 111.455C165.373 101.104 157.018 96.671 157.018 96.671L182.107 92.3303L181.762 91.0292C183.459 90.364 184.968 89.2928 186.158 87.909L187.512 79.9068C185.217 72.63 174.348 69.1298 163.411 70.8454C152.141 72.6185 149.272 76.8326 149.272 76.8326C149.272 76.8326 133.353 76.6138 124.298 84.1554C115.243 91.697 120.763 103.66 123.632 107.874C126.069 111.15 128.805 114.191 131.804 116.959C131.804 116.959 132.469 125.605 133.135 129.82C133.801 134.034 123.449 145.824 123.449 145.824L138.472 168.656L155.492 155.357C155.492 155.357 173.855 153.999 180.006 152.329L181.785 151.581C181.785 151.581 162.929 153.354 158.487 147.931Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M171.396 106.768C171.396 106.768 171.396 106.422 171.396 105.881C171.396 104.166 171.683 100.458 174.541 99.445C178.294 98.1209 181.427 101.667 181.427 101.667L181.645 105.213C181.105 104.536 180.396 104.015 179.589 103.704C178.782 103.392 177.908 103.301 177.055 103.44C174.858 103.903 172.872 105.071 171.396 106.768Z",
    fill: "#666666"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M177.814 113.864C177.814 115.694 177.309 117.191 176.666 117.191C176.024 117.191 175.519 115.694 175.519 113.864C175.519 112.033 176.012 110.536 176.666 110.536C177.32 110.536 177.814 112.021 177.814 113.864Z",
    fill: "#666666"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M170.849 137.086C169.621 138.364 167.979 138.779 167.188 138.019C166.396 137.259 166.751 135.589 167.979 134.311C169.207 133.033 170.837 132.619 171.629 133.379C172.421 134.139 172.077 135.808 170.849 137.086Z",
    fill: "#666666"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M131.839 116.962C131.839 116.962 132.505 125.609 133.17 129.823C133.836 134.037 123.449 145.827 123.449 145.827L138.473 168.659L155.493 155.36C155.493 155.36 179.594 153.587 181.786 151.584C183.978 149.58 184.001 127.646 184.001 127.646L189.739 124.319C189.739 124.319 184.437 101.291 183.117 96.156L181.786 91.0668C181.786 91.0668 189.521 88.3956 187.754 80.7043C185.987 73.013 174.716 69.1904 163.446 70.9405C152.176 72.6907 149.307 76.9278 149.307 76.9278C149.307 76.9278 133.388 76.709 124.333 84.2506C115.278 91.7922 120.798 103.755 123.667 107.969C126.109 111.213 128.845 114.223 131.839 116.962V116.962Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M153.059 95.2338C157.041 92.5741 181.751 91.0312 181.751 91.0312C181.751 91.0312 189.486 88.36 187.719 80.6687C185.951 72.9774 174.681 69.1548 163.411 70.9049C152.141 72.655 149.272 76.8921 149.272 76.8921C149.272 76.8921 133.353 76.6734 124.298 84.215C115.243 91.7566 120.763 103.72 123.632 107.934C126.069 111.209 128.805 114.251 131.804 117.018C131.804 117.018 132.171 121.762 132.63 125.941L139.516 127.887L147.034 123.892L154.551 122.119C154.551 122.119 149.019 117.905 152.118 113.921C155.217 109.937 160.955 108.601 161.173 105.493C161.391 102.384 149.076 97.8935 153.059 95.2338Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M177.18 82.3486C177.18 82.3486 174.586 77.5819 179.338 78.4454C184.089 79.309 184.089 87.5529 180.199 89.28C176.308 91.0071 155.145 87.1154 143.473 90.5811C131.801 94.0468 123.606 103.58 123.606 103.58",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M130.093 110.951C130.093 110.951 139.171 103.157 146.505 101.855C153.838 100.554 157.74 100.554 149.534 105.31C141.329 110.065 146.941 109.201 152.128 107.474",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    fill: "#605BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M149.077 128.048C149.077 128.048 147.757 114.081 140.906 113.644C134.054 113.206 134.272 123.177 136.315 130.051C138.358 136.925 143.201 139.136 147.138 135.589",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M124.058 137.36L146.162 171.062L135.994 184.141C131.414 175.278 126.325 166.69 120.753 158.419C113.235 147.78 112.352 146.007 112.352 146.007L124.058 137.36Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M124.058 137.36L112.352 146.007C112.352 146.007 113.006 147.308 117.826 154.251L130.198 146.721L124.058 137.36Z",
    fill: "#605BFF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.058 137.36L112.352 146.007C112.352 146.007 113.006 147.308 117.826 154.251L130.198 146.721L124.058 137.36Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M124.058 137.36L146.162 171.062L135.994 184.141C131.414 175.278 126.325 166.69 120.753 158.419C113.235 147.78 112.352 146.007 112.352 146.007L124.058 137.36Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M180.901 221.173C180.901 221.173 184.436 213.85 185.102 209.198C185.768 204.547 185.986 201.875 188.637 199.665C191.288 197.454 199.907 188.577 201.261 185.249C202.616 181.922 203.465 185.031 204.13 187.69C204.796 190.35 204.567 192.791 202.363 194.345C200.81 195.501 199.4 196.839 198.163 198.329L200.148 199.884C200.148 199.884 227.773 189.463 230.653 188.37C233.534 187.276 236.174 188.139 236.392 190.361C236.61 192.584 235.738 192.802 234.406 193.47C233.075 194.138 218.499 199.227 216.502 200.114L214.517 201L216.066 202.555C216.066 202.555 224.02 202.336 228.002 202.117C231.985 201.898 237.941 201.231 238.825 202.555C239.219 203.147 239.37 203.87 239.246 204.571C239.122 205.273 238.733 205.899 238.159 206.32C237.695 206.767 237.135 207.102 236.523 207.302C235.911 207.501 235.262 207.559 234.624 207.471C232.639 207.471 215.619 208.795 215.619 208.795L216.066 211.236C216.066 211.236 234.188 214.115 234.842 215.001C235.497 215.888 235.508 216.337 234.842 217.661C234.177 218.985 233.695 218.997 231.973 218.997C230.252 218.997 215.906 216.774 215.906 216.774C215.906 216.774 222.975 220.77 223.859 221.438C224.743 222.105 227.83 222.589 226.946 224.097C226.063 225.606 225.627 226.089 224.295 225.87C222.964 225.652 213.473 221.438 213.473 221.438C213.473 221.438 203.97 222.762 200.848 222.992C198.55 223.099 196.248 223.022 193.962 222.762L185.125 228.519L180.901 221.173Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M118.146 211.188C118.146 211.188 111.731 184.361 109.08 178.374C106.429 172.386 91.4054 166.86 84.1062 179.928C76.8069 192.996 83.4405 207.861 86.1031 218.499C88.7657 229.138 105.545 277.22 107.978 283.242C110.411 289.264 114.864 287.848 117.263 287.237C119.661 286.627 186.87 232.247 186.87 232.247L181.567 220.284L129.417 247.146L118.146 211.188Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M116.263 270.177C117.966 264.987 119.931 259.888 122.151 254.898C124.607 249.97 110.364 266.239 107.414 257.362C104.465 248.485 85.8035 204.133 89.2351 189.349C90.7236 182.481 94.7296 176.424 100.459 172.378C94.985 171.077 88.2825 172.459 84.105 179.943C76.8172 193.022 83.4393 207.875 86.1019 218.514C88.7645 229.153 105.544 277.235 107.977 283.257C110.41 289.279 114.863 287.862 117.261 287.252C119.029 286.769 155.135 257.834 174.646 242.141L116.263 270.177Z",
    fill: "#605BFF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.263 270.177C117.966 264.987 119.931 259.888 122.151 254.898C124.607 249.97 110.364 266.239 107.414 257.362C104.465 248.485 85.8035 204.133 89.2351 189.349C90.7236 182.481 94.7296 176.424 100.459 172.378C94.985 171.077 88.2825 172.459 84.105 179.943C76.8172 193.022 83.4393 207.875 86.1019 218.514C88.7645 229.153 105.544 277.235 107.977 283.257C110.41 289.279 114.863 287.862 117.261 287.252C119.029 286.769 155.135 257.834 174.646 242.141L116.263 270.177Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M118.146 211.188C118.146 211.188 111.731 184.361 109.08 178.374C106.429 172.386 91.4054 166.86 84.1062 179.928C76.8069 192.996 83.4405 207.861 86.1031 218.499C88.7657 229.138 105.545 277.22 107.978 283.242C110.411 289.264 114.864 287.848 117.263 287.237C119.661 286.627 186.87 232.247 186.87 232.247L181.567 220.284L129.417 247.146L118.146 211.188Z",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M173.835 224.72L179.803 236.913",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6426 163.546L3.11426 184.79C3.11426 184.79 18.1604 200.748 16.611 242.612C15.4633 274.586 19.6753 310.89 25.7924 318.27H58.2948C58.2948 318.27 47.059 256.095 47.8623 220.471C48.4936 193.402 40.3909 174.611 33.6426 163.546Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3135 163.546L6.78516 184.79C6.78516 184.79 21.8313 200.748 20.2704 242.612C19.1227 274.586 23.3347 310.89 29.4519 318.27H61.9657C61.9657 318.27 50.7413 256.095 51.5447 220.471C52.153 193.402 44.0504 174.611 37.3135 163.546Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6418 163.546H37.3144L6.78611 184.79H3.125L33.6418 163.546Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M175.654 368.86V370.354C176.122 370.318 176.698 370.282 177.31 370.282C178.318 370.282 182.512 370.282 183.52 370.282C184.024 370.282 184.654 370.318 185.194 370.354V368.86C184.672 368.914 184.024 368.95 183.52 368.95C182.512 368.95 178.318 368.95 177.274 368.95C176.698 368.95 176.158 368.914 175.654 368.86ZM173.512 373.378V374.872C173.998 374.836 174.538 374.818 175.078 374.818C176.122 374.818 185.896 374.818 186.85 374.818C187.3 374.818 187.876 374.836 188.272 374.872V373.378C187.822 373.432 187.228 373.468 186.85 373.468C185.896 373.468 176.122 373.468 175.078 373.468C174.52 373.468 173.998 373.432 173.512 373.378ZM181.99 374.098L180.478 374.116C180.46 376.096 180.334 377.86 179.434 379.282C178.714 380.434 177.418 381.46 176.032 382.054L177.364 383.026C178.894 382.252 180.244 380.956 180.91 379.75C181.702 378.238 181.99 376.366 181.99 374.098ZM186.13 367.384L185.176 367.798C185.662 368.482 186.274 369.562 186.616 370.282L187.588 369.85C187.228 369.13 186.58 368.032 186.13 367.384ZM188.092 366.664L187.156 367.078C187.66 367.744 188.254 368.77 188.65 369.544L189.604 369.112C189.262 368.446 188.578 367.33 188.092 366.664ZM191.818 374.206V375.97C192.394 375.934 193.348 375.898 194.338 375.898C195.67 375.898 202.852 375.898 204.22 375.898C205.012 375.898 205.768 375.952 206.146 375.97V374.206C205.732 374.242 205.102 374.314 204.202 374.314C202.87 374.314 195.652 374.314 194.338 374.314C193.312 374.314 192.376 374.26 191.818 374.206ZM215.47 373.756L214.48 374.764C216.712 376.15 219.79 378.364 221.446 379.876L222.508 378.616C220.726 377.176 217.774 375.106 215.47 373.756ZM223.696 370.48L222.508 369.76C222.22 369.868 221.824 369.922 221.338 369.922H215.614L215.038 371.218H221.698C221.284 372.892 220.15 375.178 218.764 376.834C217.144 378.76 214.696 380.668 211.348 381.676L212.626 382.81C216.046 381.55 218.386 379.624 220.024 377.608C221.608 375.664 222.742 373.27 223.282 371.434C223.372 371.146 223.552 370.732 223.696 370.48ZM217.63 367.87L215.992 367.348C215.884 367.816 215.596 368.464 215.416 368.77C214.588 370.426 212.734 373.126 209.656 375.052L210.844 375.97C213.724 373.99 215.758 371.272 216.82 369.292C217 368.95 217.324 368.338 217.63 367.87ZM227.728 370.66L227.836 372.01C228.502 372.028 229.276 372.046 229.942 372.046C232.138 372.064 234.496 371.668 236.26 371.182L236.224 369.85C234.154 370.534 231.886 370.768 229.942 370.768C229.168 370.768 228.394 370.732 227.728 370.66ZM234.118 367.726L232.534 367.564C232.48 368.824 232.084 370.408 231.688 371.542C230.95 373.666 229.276 376.87 227.674 378.742L229.06 379.462C230.554 377.446 232.21 374.17 233.074 371.578C233.506 370.3 233.884 368.608 234.118 367.726ZM238.366 373.288H236.944C237.016 375.268 237.214 378.49 237.214 379.858C237.214 380.83 236.71 381.622 235.216 381.622C233.812 381.622 233.11 381.046 233.11 380.218C233.11 379.39 234.01 378.778 235.342 378.778C237.988 378.778 240.058 380.38 241.444 381.64L242.2 380.416C240.724 379.138 238.402 377.626 235.378 377.626C233.362 377.626 231.796 378.67 231.796 380.326C231.796 382.126 233.398 382.918 235.378 382.918C237.61 382.918 238.528 381.748 238.528 380.308C238.528 379.12 238.366 376.384 238.33 375.214C238.312 374.566 238.312 374.026 238.366 373.288ZM241.966 373.756L242.776 372.568C241.912 371.92 239.878 370.75 238.564 370.192L237.844 371.272C239.032 371.83 240.994 372.928 241.966 373.756ZM250.12 367.978H248.284C248.392 368.5 248.446 369.13 248.446 369.796C248.446 371.686 248.266 376.24 248.266 378.904C248.266 381.856 250.048 382.918 252.64 382.918C256.582 382.918 258.922 380.668 260.146 378.958L259.138 377.734C257.842 379.606 255.97 381.442 252.676 381.442C250.966 381.442 249.724 380.758 249.724 378.778C249.724 376.096 249.868 371.83 249.94 369.796C249.976 369.202 250.03 368.572 250.12 367.978Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.1aac519298b55a4e98581d60fbe197ae.svg";
export { ForwardRef as ReactComponent };